import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-download-white.svg'


const _hoisted_1 = { class: "modal-container" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "section-item" }
const _hoisted_4 = { class: "section-item" }
const _hoisted_5 = {
  key: 0,
  class: "stages-selection"
}
const _hoisted_6 = { class: "stages-header" }
const _hoisted_7 = { class: "stages-grid" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = { class: "stage-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.isOpen)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "modal-overlay",
        onClick: _withModifiers($setup.close, ["self"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "modal-title" }, "Export PDF Report", -1)),
            _createElementVNode("button", {
              class: "close-btn",
              onClick: $setup.close
            }, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("span", null, "×", -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "modal-description" }, "Select which sections and stages to include in your exported report", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "section-header",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleSection('overview')))
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "checkbox-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.sections.overview.selected) = $event)),
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, null, 512), [
                  [_vModelCheckbox, $setup.sections.overview.selected]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "section-info" }, [
                  _createElementVNode("div", { class: "section-title" }, "Project Overview"),
                  _createElementVNode("div", { class: "section-subtitle" }, "Complete snapshot of all lots across the entire project")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "section-header",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleSection('breakdown')))
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "checkbox-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.sections.breakdown.selected) = $event)),
                  onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                }, null, 512), [
                  [_vModelCheckbox, $setup.sections.breakdown.selected]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "section-info" }, [
                  _createElementVNode("div", { class: "section-title" }, "Stage-by-Stage Breakdown"),
                  _createElementVNode("div", { class: "section-subtitle" }, "Detailed status breakdown and lot information per stage")
                ], -1))
              ]),
              ($setup.sections.breakdown.selected)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "stages-label" }, "Select stages to include:", -1)),
                      _createElementVNode("button", {
                        class: "select-all-btn",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.selectAllStages('breakdown')))
                      }, "Select All")
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.stages, (stage) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "stage-checkbox",
                          key: stage._id,
                          onClick: ($event: any) => ($setup.toggleStage('breakdown', stage._id))
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "checkbox-input",
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => (($setup.sections.breakdown.stages[stage._id]) = $event),
                            onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                          }, null, 8, _hoisted_9), [
                            [_vModelCheckbox, $setup.sections.breakdown.stages[stage._id]]
                          ]),
                          _createElementVNode("span", _hoisted_10, "Stage " + _toDisplayString(stage.title), 1)
                        ], 8, _hoisted_8))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              class: "cancel-btn",
              onClick: $setup.close
            }, "Cancel"),
            _createElementVNode("button", {
              class: "generate-btn",
              onClick: $setup.generatePDF
            }, [...(_cache[14] || (_cache[14] = [
              _createElementVNode("img", {
                class: "download-icon",
                src: _imports_0
              }, null, -1),
              _createTextVNode("Generate PDF", -1)
            ]))])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}